import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
// import { selectisAuthenticated } from "../../../features/auth/authSlice";
import {
  selectPriseEnChargeGrid,
  PriseEnChargeDATAllRows,
} from "../../features/PriseEnCharge/PriseEnChargeSlice";
import { Button, Form, Container, Card, Grid } from "semantic-ui-react";
import { useQuery } from "react-query";
import { useSelector, useDispatch } from "react-redux";
import { GetAllType_D_Operation, GetALLCLINICS } from "../Api/api";
import { server } from "../../App";
import { toast } from "react-toastify";
import axios from "axios";
import { useWindowSize } from "react-use";
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"
import useGetDoctors from "../../CustomHooks/useGetDoctors";

function UpdatePriseEnCarge() {
  const data = useGetDoctors()
  const [show, setShow] = useState(true)
  const { register, handleSubmit } = useForm();
  //   const PatientelleState = useSelector(selectPatientelleGrid);
  const PriseEnChargeState = useSelector(selectPriseEnChargeGrid);
  const dispatch = useDispatch();
  const { width } = useWindowSize();

  const { priseEnChargeData, GlobalYear, GlobalMonth } = PriseEnChargeState;
  const {
    nom_mutuelle,
    idPriseEnCharge,
    FK_id_Patient_Prise,
    civilite,
    NomPrenom,
    age,
    pathologie_principale,
    tel,
    fk_id_clinique,
    dateDeSoumissionServer,
    statut,
    contact,
    FK_id_medecin2,
    comentaire,
    idType_D_Operation,

    cin,
    date_naissanceLisible,
  } = priseEnChargeData;

  sessionStorage.setItem("ID_PriseEnCharge", idPriseEnCharge);

  const Type_D_Operation = useQuery("GetAllType_D_Operation", () =>
    GetAllType_D_Operation()
  );

  let Type_D_Operation_list = "";

  if (Type_D_Operation?.data) {
    Type_D_Operation_list = (
      <select
        defaultValue={idType_D_Operation}
        name="FK_id_type_D_Operation"
        // role="listbox"
        aria-expanded="false"
        className="ui selection dropdown"
        required
        {...register("FK_id_type_D_Operation")}
      >
        <option className="item" value={0}>
          choisissez une option
        </option>
        {Type_D_Operation?.data.map((item, index) => (
          <option className="item" key={index} value={item.idType_D_Operation}>
            {item.Nom_Type_D_Operationcol}
          </option>
        ))}
      </select>
    );
  }

  const Type_clinic = useQuery("GetALLCLINICS", () =>
    GetALLCLINICS()
  );

  let Type_clinic_list = "";

  if (Type_clinic?.data) {
    Type_clinic_list = Type_clinic?.data.map((item, index) => (
      <option className="item" key={index} value={item.idclinique}>
        {item.NomClinique}
      </option>
    ));
  }

  const GetData = async () => {
    // console.log("data", data);
    let url;

    url = `${server}PriseEnCharge/YearMonth/${GlobalYear}-${GlobalMonth}`;

    axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(PriseEnChargeDATAllRows(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const UpdateOneUser = (data) => {
    return axios({
      method: "PUT",
      responseType: "json",
      url: `${server}PriseEnCharge`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        GetData();
        toast.success("Successfully updated", {
          position: toast.POSITION.TOP_CENTER,
        });
        setShow(false)
        return response;
      })
      .catch(() =>
        toast.error("error", {
          position: toast.POSITION.TOP_CENTER,
        })
      );
  };

  // {dateDeSoumission,statut,contact,FK_id_Patient_Prise,fk_id_clinique,FK_id_type_D_Operation}
  // http://localhost:23046/PriseEnCharge/GetAllType_D_Operation

  //   console.log(contact.slice(0, 16));
  const onSubmit = (data) => {
    data.idPriseEnCharge = idPriseEnCharge;
    data.FK_id_Patient_Prise = FK_id_Patient_Prise;
    UpdateOneUser(data);
    // console.log(data);
  };

  let displayLayout = "";
  if (width < 900 && width > 450) {
    displayLayout = (
      <Grid columns="equal" centered className="fixWidth">
        <Grid.Row className="NonPaddingBotom">
          <Grid.Column>
            <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <div className="required field">
                <label>Clinique</label>
                <select
                  defaultValue={fk_id_clinique}
                  name="fk_id_clinique"
                  // role="listbox"
                  aria-expanded="false"
                  className="ui selection dropdown"
                  {...register("fk_id_clinique")}
                >
                  <option className="item" value={0}>
                    choisissez une option
                  </option>
                  {Type_clinic_list}
                </select>
              </div>

              <div className="required field">
                <label>Opération</label>

                {Type_D_Operation_list}
              </div>

              <div className="required field">
                <label>Date de soumission</label>
                <div className="ui input">
                  <input
                    defaultValue={dateDeSoumissionServer}
                    type="date"
                    name="dateDeSoumission"
                    required
                    min="1900-01-01"
                    max="3018-12-31"
                    {...register("dateDeSoumission")}
                  ></input>
                </div>
              </div>

              <Button floated="right" positive>
                Enregistrer
              </Button>
              <Link to="/PriseEnCharge">
                <Button floated="right" color="blue">
                  retour
                </Button>
              </Link>
            </Form>
          </Grid.Column>
          <Grid.Column>
            <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <div className="required field">
                <label>Statut</label>
                <select
                  name="statut"
                  // role="listbox"
                  defaultValue={statut}
                  aria-expanded="false"
                  className="ui selection dropdown"
                  {...register("statut")}
                >
                  <option className="item" value={0}>
                    En cours
                  </option>
                  <option className="item" value={1}>
                    Validé
                  </option>
                </select>
              </div>
              <div className="required field">
                <label>Contact</label>
                <div className="ui input">
                  <input
                    defaultValue={contact ? contact.slice(0, 16) : ""}
                    type="datetime-local"
                    name="dateDeSoumission"
                    // min="2022-01-01"
                    // max="3018-12-31"
                    {...register("contact")}
                  ></input>
                </div>
              </div>

              <div className="required field">
                <label>Medecin</label>
                <select
                  name="FK_id_medecin2"
                  // role="listbox"
                  defaultValue={FK_id_medecin2}
                  aria-expanded="false"
                  className="ui selection dropdown"
                  required
                  {...register("FK_id_medecin2")}
                >
                  {data?.Doctors_list}
                </select>
              </div>

              <div className=" field">
                <label>Commentaire</label>
                <div className="ui form">
                  <textarea
                    defaultValue={comentaire}
                    placeholder="Commentaire"
                    name="comentaire"
                    maxLength={9000}
                    type="text"
                    {...register("comentaire")}
                    rows="3"
                  />
                </div>
              </div>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  } else {
    displayLayout = (
      <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <Form.Group widths="equal">
          <div className="required field">
            <label>Clinique</label>
            <select
              defaultValue={fk_id_clinique}
              name="fk_id_clinique"
              // role="listbox"
              aria-expanded="false"
              className="ui selection dropdown"
              {...register("fk_id_clinique")}
            >
              <option className="item" value={0}>
                choisissez une option
              </option>
              {Type_clinic_list}
            </select>
          </div>

          <div className="required field">
            <label>Opération</label>

            {Type_D_Operation_list}
          </div>

          <div className="required field">
            <label>Date de soumission</label>
            <div className="ui input">
              <input
                defaultValue={dateDeSoumissionServer}
                type="date"
                name="dateDeSoumission"
                required
                min="1900-01-01"
                max="3018-12-31"
                {...register("dateDeSoumission")}
              ></input>
            </div>
          </div>
        </Form.Group>
        <Form.Group widths="equal">
          <div className="required field">
            <label>Statut</label>
            <select
              name="statut"
              // role="listbox"
              defaultValue={statut}
              aria-expanded="false"
              className="ui selection dropdown"
              {...register("statut")}
            >
              <option className="item" value={0}>
                En cours
              </option>
              <option className="item" value={1}>
                Validé
              </option>
            </select>
          </div>
          <div className="required field">
            <label>Contact</label>
            <div className="ui input">
              <input
                defaultValue={contact ? contact.slice(0, 16) : ""}
                type="datetime-local"
                name="dateDeSoumission"
                // min="2022-01-01"
                // max="3018-12-31"
                {...register("contact")}
              ></input>
            </div>
          </div>
          <div className="required field">
            <label>Medecin</label>
            <select
              name="FK_id_medecin2"
              // role="listbox"
              defaultValue={FK_id_medecin2}
              aria-expanded="false"
              className="ui selection dropdown"
              required
              {...register("FK_id_medecin2")}
            >
              {data?.Doctors_list}
            </select>
          </div>
          <div className=" field">
            <label>Commentaire</label>
            <div className="ui form">
              <textarea
                defaultValue={comentaire}
                placeholder="Commentaire"
                name="comentaire"
                maxLength={9000}
                type="text"
                {...register("comentaire")}
                rows="3"
              />
            </div>
          </div>
        </Form.Group>
        {show ?
          <Button floated="right" positive>
            Enregistrer
          </Button> : ""
        }

        <Link to="/PriseEnCharge">
          <Button floated="right" color="blue">
            retour
          </Button>
        </Link>
      </Form>
    );
  }

  return (
    <>
      <div className="heightFix">
        <br />
        <br />
        <br />
        <Container>
          {/* <Grid> */}
          {/* <Grid.Row> */}
          {/* <Grid.Column></Grid.Column> */}
          {/* <Grid.Column> */}
          <Card centered raised>
            <Card.Content>
              <Card.Header>
                {civilite} {NomPrenom}
              </Card.Header>
              <Card.Meta>
                Age : {parseInt(age)} ans <br></br> Cin : {cin}{" "}
              </Card.Meta>
              <Card.Description>
                Mutuelle : {nom_mutuelle} <br></br> Date de naissance :{" "}
                {date_naissanceLisible} <br></br>Tel : {tel} <br></br>
                Pathologie principale : {pathologie_principale}
              </Card.Description>
            </Card.Content>
          </Card>
          {/* </Grid.Column> */}
          {/* <Grid.Column></Grid.Column> */}
          {/* </Grid.Row> */}
          {/* </Grid> */}
          <br />
          <br />
          {displayLayout}
          {/* ================READ FILE LOGIC======================= */}
          {/* <input name="textfile" type="file" accept="text/plain" ref={register} onChange={q} /> */}
          {/* ================READ FILE LOGIC======================= */}

          {/* {loadingComponent} */}
        </Container>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
      <SpeedDialComponent />
    </>
  );
}

export default UpdatePriseEnCarge;
